import Router from 'pages/_router'

export default function App() {
  return <Router />
}
